var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0973935484 4.40993007 0.0973935484 4.40993007 2.81352258 0 2.81352258"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "-9.32400932e-05 0.0121290323 8.24637141 0.0121290323 8.24637141 5.85503226 -9.32400932e-05 5.85503226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.130567211 0.0121290323 8.37703186 0.0121290323 8.37703186 5.85505806 0.130567211 5.85505806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.0819269619 0.0973677419 4.49184149 0.0973677419 4.49184149 2.81349677 0.0819269619 2.81349677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "-0.000124320124 0.0973290323 8.84304584 0.0973290323 8.84304584 6.62403871 -0.000124320124 6.62403871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0.0513286713 0.115096774 7.75524476 0.115096774 7.75524476 4.8596129 0.0513286713 4.8596129"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 0.0973935484 7.70394716 0.0973935484 7.70394716 4.84242581 0 4.84242581"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "1.55400155e-05 0.0121290323 24.2276612 0.0121290323 24.2276612 19.9565032 1.55400155e-05 19.9565032"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.134879179
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#1D2088",
    points: "0 5.36123447 0 6.85835738 0 7.27272727 4.24242424 7.27272727 0 4.84848485"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1D2088",
    points: "20 7.27272727 24.2424242 7.27272727 24.2424242 4.84848485"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3844444,13.9412774 L15.3844444,19.9565032 L22.6748873,19.9565032 C22.738446,19.9337935 22.8001399,19.9086323 22.8607459,19.8820516 C22.891826,19.8685032 22.9215074,19.8535355 22.9514996,19.8388258 C22.9841336,19.8230839 23.0166123,19.8070839 23.0481585,19.7900516 C23.0814141,19.7723742 23.1140482,19.7537935 23.1463714,19.7348258 C23.1715462,19.7199871 23.1957887,19.7046323 23.2200311,19.6892774 C23.2549961,19.6668258 23.2901166,19.6446323 23.323683,19.6207613 C23.3303652,19.6159871 23.3365812,19.6106968 23.3437296,19.6060516 C23.4312199,19.5424387 23.5138928,19.4743097 23.5906605,19.4015355 C23.5929915,19.3990839 23.5959441,19.3965032 23.5987413,19.3939226 C23.6368143,19.3577935 23.6727117,19.3202452 23.7075214,19.2817935 C23.713582,19.2749548 23.7196426,19.2683742 23.7255478,19.2615355 C23.7605128,19.2223097 23.7947009,19.1816645 23.8264025,19.1401161 L15.3844444,13.9412774 Z",
    id: "Fill-3",
    fill: "#1D2088"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 12.516129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#1D2088",
    mask: "url(#mask-2)",
    points: "-1.55400155e-05 0.0973935484 -1.55400155e-05 0.908103226 -1.55400155e-05 2.81352258 4.40993007 0.0973935484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(15.384615, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24637141,0.776580645 C7.77597514,0.309225806 7.06937063,0.0120645161 6.27931624,0.0120645161 L6.27885004,0.0120645161 L-9.32400932e-05,0.0120645161 L-9.32400932e-05,5.85503226 L8.24637141,0.776580645 Z",
    id: "Fill-8",
    fill: "#1D2088",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.466200, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37703186,0.0120903226 L2.09808858,0.0120903226 C1.30756799,0.0120903226 0.600963481,0.309509677 0.130567211,0.776735484 L8.37703186,5.85505806 L8.37703186,0.0120903226 Z",
    id: "Fill-11",
    fill: "#1D2088",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.84323232,13.9412774 L0.401740482,19.1403742 C0.401740482,19.1407613 0.402051282,19.1411484 0.402206682,19.1414065 C0.432975913,19.1816645 0.465765346,19.2205032 0.49964258,19.2588258 C0.507412587,19.2676 0.515493395,19.2762452 0.523108003,19.2848903 C0.556519037,19.3214065 0.590862471,19.3574065 0.627070707,19.3919871 C0.633597514,19.3984387 0.640745921,19.4045032 0.647583528,19.4108258 C0.715804196,19.4750839 0.789153069,19.5353419 0.866076146,19.5923742 C0.87975136,19.6021806 0.892183372,19.6126323 0.905858586,19.6223097 C0.936938617,19.6443742 0.969261849,19.6645032 1.00111888,19.6851484 C1.02878011,19.7025677 1.05675214,19.7203742 1.08503497,19.7371484 C1.11456099,19.7546968 1.14486402,19.771729 1.17563326,19.7881161 C1.21075369,19.8070839 1.24665113,19.8247613 1.28301476,19.8423097 C1.30989899,19.8552129 1.33647242,19.8687613 1.36397824,19.8808903 C1.42613831,19.9081161 1.48860917,19.9332774 1.55310023,19.9565032 L8.84323232,19.9565032 L8.84323232,13.9412774 Z",
    id: "Fill-14",
    fill: "#1D2088"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(19.735820, 12.516129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#1D2088",
    mask: "url(#mask-8)",
    points: "4.49187257 2.81349677 4.49187257 0.0973677419 0.0819269619 0.0973677419"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.84323232,7.18219355 L8.84323232,5.85509677 L0.596767677,0.776645161 C0.224428904,1.14619355 3.10800311e-05,1.62167742 3.10800311e-05,2.14103226 L3.10800311e-05,2.43767742 L7.70430458,7.18219355 L8.84323232,7.18219355 Z",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(15.384615, 12.516129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84307692,4.84197419 L1.13942502,0.0973290323 L-0.000124320124,0.0973290323 L-0.000124320124,1.4252 L8.44183372,6.62403871 C8.50026418,6.54816774 8.55185703,6.46868387 8.59878788,6.38687742 C8.60360528,6.3775871 8.60935509,6.3688129 8.61432789,6.35990968 C8.63297591,6.3252 8.65053613,6.28997419 8.66716395,6.25436129 C8.67804196,6.23178065 8.68783217,6.2088129 8.69746698,6.18610323 C8.71052059,6.15526452 8.723885,6.12429677 8.73538462,6.0928129 C8.75434343,6.04029677 8.77097125,5.98700645 8.78480186,5.9332 C8.79039627,5.91229677 8.79428127,5.89100645 8.79909868,5.86971613 C8.80842269,5.82610323 8.8168143,5.78223226 8.8230303,5.73784516 C8.82644911,5.71771613 8.82893551,5.69771613 8.83126651,5.67745806 C8.83794872,5.61565161 8.84261072,5.5532 8.84307692,5.48984516 L8.84307692,5.48390968 L8.84307692,4.84197419 Z",
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#FFFFFF",
    points: "5.50865579 7.18219355 3.10800311e-05 3.78980645 3.10800311e-05 4.46670968 4.40997669 7.18219355"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#FFFFFF",
    points: "18.7197824 12.6135226 24.2276301 16.0059097 24.2276301 15.3296516 19.8176845 12.6135226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#E60012",
    points: "7.70428904 7.18219355 1.55400155e-05 2.43767742 1.55400155e-05 3.78980645 5.50864025 7.18219355"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#E60012",
    points: "16.5240093 12.6135226 24.2276612 17.3581677 24.2276612 16.0059097 18.7198135 12.6135226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3844444,6.53110968 L23.9821134,1.23652903 C23.8880963,1.07059355 23.77108,0.915367742 23.6309091,0.776529032 L15.3844444,5.85510968 L15.3844444,6.53110968 Z",
    id: "Fill-32",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84323232,13.2648645 L0.117668998,18.6385419 C0.118135198,18.6402194 0.119378399,18.6417677 0.1198446,18.6434452 C0.151235431,18.7255097 0.18961927,18.8052516 0.232820513,18.8824129 C0.23950272,18.894671 0.246651127,18.9064129 0.253799534,18.9181548 C0.297933178,18.9941548 0.346262626,19.0679613 0.40034188,19.138671 C0.400652681,19.1391871 0.400963481,19.1399613 0.401740482,19.1403484 L8.84323232,13.9412516 L8.84323232,13.2648645 Z",
    id: "Fill-34",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(16.472416, 2.322581)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#FFFFFF",
    mask: "url(#mask-12)",
    points: "3.34534577 4.8596129 7.75529138 2.14412903 7.75529138 0.115096774 0.0513286713 4.8596129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(0.000000, 12.516129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#FFFFFF",
    mask: "url(#mask-14)",
    points: "4.40993007 0.0973935484 -1.55400155e-05 2.81352258 -1.55400155e-05 4.84242581 7.70394716 0.0973935484"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.84323232,12.6135226 L7.70399378,12.6135226 L3.10800311e-05,17.3585548 L3.10800311e-05,17.9999742 C3.10800311e-05,18.0661677 0.00484848485,18.1312 0.0118414918,18.1961032 C0.0143278943,18.2161032 0.0174358974,18.2359742 0.0203885004,18.2559742 C0.0270707071,18.3015226 0.0351515152,18.3465548 0.0450971251,18.3909419 C0.0497591298,18.4118452 0.0544211344,18.4331355 0.0598601399,18.4536516 C0.0733799534,18.5060387 0.0895415695,18.5577806 0.107567988,18.6083613 C0.111452991,18.6177806 0.113783994,18.6278452 0.117202797,18.6371355 C0.117513598,18.6377806 0.117668998,18.6381677 0.117668998,18.6385548 L8.84323232,13.2648774 L8.84323232,12.6135226 Z",
    id: "Fill-42",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3844444,7.18219355 L16.523683,7.18219355 L24.2276457,2.43767742 L24.2276457,2.14103226 L24.2276457,2.13909677 C24.2271795,1.81612903 24.137669,1.51070968 23.9821134,1.23651613 L15.3844444,6.53109677 L15.3844444,7.18219355 Z",
    id: "Fill-44",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#FFFFFF",
    points: "8.84323232 7.18219355 7.70430458 7.18219355 5.50865579 7.18219355 4.40997669 7.18219355 3.10800311e-05 7.18219355 3.10800311e-05 8.26864516 8.84323232 8.26864516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#FFFFFF",
    points: "15.3844444 12.6135226 16.5239938 12.6135226 18.719798 12.6135226 19.8177001 12.6135226 24.2276457 12.6135226 24.2276457 11.527329 15.3844444 11.527329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#FFFFFF",
    points: "16.5236985 7.18219355 15.38446 7.18219355 15.38446 8.26864516 24.2276612 8.26864516 24.2276612 7.18219355 19.8177156 7.18219355"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FFFFFF",
    points: "7.70397824 12.6135226 8.84321678 12.6135226 8.84321678 11.527329 1.55400155e-05 11.527329 1.55400155e-05 12.6135226 4.40996115 12.6135226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#FFFFFF",
    points: "14.0765967 11.5273419 14.0765967 19.9565032 15.3844444 19.9565032 15.3844444 13.9412774 15.3844444 12.6135355 15.3844444 11.5273419"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#FFFFFF",
    points: "8.84323232 7.18219355 8.84323232 8.26864516 10.1517016 8.26864516 10.1517016 0.0121290323 8.84323232 0.0121290323 8.84323232 5.85509677"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#FFFFFF",
    points: "15.3844444 8.26864516 15.3844444 7.18219355 15.3844444 6.53109677 15.3844444 5.85509677 15.3844444 0.0121290323 14.0765967 0.0121290323 14.0765967 8.26864516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#FFFFFF",
    points: "8.84323232 11.5273419 8.84323232 12.6135355 8.84323232 13.2648903 8.84323232 13.9412774 8.84323232 19.9565032 10.1517016 19.9565032 10.1517016 11.5273419"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#E60012",
    mask: "url(#mask-16)",
    points: "10.1516861 11.5273419 10.1516861 19.9565032 14.0766278 19.9565032 14.0766278 11.5273419 15.3844755 11.5273419 24.2276768 11.5273419 24.2276768 8.26863226 15.3844755 8.26863226 14.0766278 8.26863226 14.0766278 0.012116129 10.1516861 0.012116129 10.1516861 8.26863226 8.84321678 8.26863226 1.55400155e-05 8.26863226 1.55400155e-05 11.5273419 8.84321678 11.5273419"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.318461d9c35c400fedb7d67e5b64b94d.svg";
export { ForwardRef as ReactComponent };